import React from 'react'

import * as T from '../../../components/Table'
import { Text } from '@chakra-ui/react'
import { Validar } from './Validar'
export const RelatorioItem = ({ item }) => {
  return (
    <T.Tr>
      <T.Td>
        <Text as="a" href={item.link_pedido_compra} color="blue.500" _hover={{ textDecoration: 'underline' }} target="_blank" rel="noreferrer">
          {item.pedido_compra}
        </Text>
      </T.Td>
      <T.Td>{item.fornecedor}</T.Td>
      <T.Td>
        <Text>{item.descricao_produto}</Text>
      </T.Td>
      <T.Td>{item.codigo_produto}</T.Td>
      <T.Td>
        <Text>{item.quantidade}</Text>
      </T.Td>
      <T.Td>
        <Validar quantidade={item.quantidade} />
      </T.Td>
    </T.Tr>
  )
}
